import axios from "axios";
import { StringFormatter } from "./StringFormatter";
import { Aesdecryption, Aesencryption } from "../Aes/Aes";
import Swal from "sweetalert2";
const Hexapi = async (props) => {
  try {
    const res = await fetch(`${process.env.PUBLIC_URL}/Apiinfo.json`);
    const data = await res.json();

    if (!data?.apipath) throw "API Path missing in Apiinfo.json";

    const url = `${data.apipath}`+`${props.url?props.url:'fetchrsdataV5.php'}`;

    let fd = new FormData();

    if (props.query && props.queryArr) {
      const formattedQueryString = StringFormatter(props.query, props.queryArr);
      fd.append(Aesencryption("Query"), Aesencryption(formattedQueryString));
      console.log(formattedQueryString)
    }
    if (props.file) fd.append(Aesencryption("file"), props.file);
    if (props.username) fd.append(Aesencryption("username"), Aesencryption(props.username));
    if (props.password) fd.append(Aesencryption("password"), Aesencryption(props.password));
    if (props.serverip) fd.append(Aesencryption("serverip"), Aesencryption(props.serverip));
    if (props.dbname) fd.append(Aesencryption("dbname"), Aesencryption(props.dbname));
    if (props.sessionid) fd.append(Aesencryption("sessionid"), Aesencryption(props.sessionid));

    const resp = await axios({
      method: "POST",
      url,
      headers: {
        "x-api-key": Aesencryption(data.apikey),                    // ✔ API Key
        "Content-Type": "multipart/form-data"       // ✔ Correct for Axios
      },
      data: fd,
    });

    let decrypted = Aesdecryption(resp.data);
    if (!decrypted) throw "Empty encrypted response";

    let responseData = JSON.parse(decrypted);

    // ----- SQL ERROR HANDLING -----
    if (responseData.sqlerrors) {
      let FData = new FormData();

      let query = `[dbo].[Hex_Web_Proc_ErrorLog_Submit]
        @UserID='{0}',
        @ErrorCode='{1}',
        @ErrorMessage='{2}',
        @SqlState='{3}'`;

      let queryArr = [
        sessionStorage.getItem("userid"),
        responseData.sqlerrors.code?.[0],
        responseData.sqlerrors.message?.[0],
        responseData.sqlerrors.sqlstate?.[0],
      ];

      let formattedQuery = StringFormatter(query, queryArr);

      FData.append(Aesencryption("Query"), Aesencryption(formattedQuery));

      const errResp = await axios({
        mode: "cors",
        method: "POST",
        url,
        headers: {
          "x-api-key": Aesencryption(data.apikey),                    // ✔ API Key
          "Content-Type": "multipart/form-data"       // ✔ Correct for Axios
        },
        data: FData,
      });

      let finalError = JSON.parse(Aesdecryption(errResp.data));

      Swal.fire({
        html: "An Error Occurred",
        allowOutsideClick: false,
        confirmButtonColor: "#F23D5E",
      });

      throw finalError?.[""]?.[0]?.msg || "Unknown SQL error";
    }

    return responseData;
  } catch (err) {
    console.error("HEXAPI ERROR:", err);
    throw err;
  }
};


export default Hexapi;
